<template>
  <div class="tab-content product-tab-content">
    <div id="products-list" class="tab-pane" :class="activeTab('list')">
      <products-new-grouped-by-asin
        :hasRefreshGroupTable="hasRefreshGroupTable"
        :currentTab="tab"
        :banner="banners.productListBanner || ''"
        @handleNotRefreshGroupTable="hasRefreshGroupTable = $event"
        @handleRefreshAmazonTable ="hasRefreshAmazonTable = $event"
      />
    </div>
    <div id="add-by-amazon" class="tab-pane" :class="activeTab('add-by-amazon')">
      <product-new-add
        :currentTab="tab"
        :banner="banners.productAddBanner || ''"
        :hasRefreshAmazonTable="hasRefreshAmazonTable"
        @handleNotRefreshAmazonTable="hasRefreshAmazonTable = $event"
        @handleRefreshGroupTable="hasRefreshGroupTable = $event"
      />
    </div>
    <div id="reports" class="tab-pane" :class="activeTab('reports')">
      <product-reports
        :currentTab="tab"
      />
    </div>
  </div>
</template>
<script>
import ProductNewAdd from './ProductNewAdd.vue'
import ProductsNewGroupedByAsin from './ProductsNewGroupedByAsin.vue'
import ProductReports from './Reports.vue'

export default {
  components: {
    ProductNewAdd,
    ProductsNewGroupedByAsin,
    ProductReports
  },
  data () {
    return {
      hasRefreshGroupTable: false,
      hasRefreshAmazonTable: false
    }
  },
  props: {
    tab: {
      type: String,
      default: 'list'
    },
    banners: {
      type: Object,
      default () {
        return {
          productListBanner: '',
          productAddBanner: ''
        }
      }
    }
  },
  methods: {
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    }
  }
}
</script>

<style scoped>
.product-tab-content {
  padding: 10px 20px 20px;
}
@media (max-width: 768px) {
  .product-tab-content {
    padding: 0;
  }
}
@media (max-width: 576px) {
  .product-tab-content {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/TabContent.vue